import mortgagesApi from '@/api/MortgagesApi';
import _ from 'lodash';

const state = {
  documents: [],
  loading: true,
  error: null,
};

const getters = {
  requiredDocuments: state => _.filter(state.documents, doc => ['REQUIRED', 'FAILED_VERIFICATION'].includes(doc.state)),
  uploadedDocuments: state => _.filter(state.documents, doc => ['UPLOADED', 'VERIFIED'].includes(doc.state)),
};

const actions = {
  async fetchMortgageDocuments({ commit }) {
    try {
      commit('setLoading', true);
      commit('setError', null);
      const documents = await mortgagesApi.getMortgageDocuments();
      commit('setDocuments', documents);
    } catch (error) {
      commit('setError', error);
      throw error;
    } finally {
      commit('setLoading', false);
    }
  },
};

const mutations = {
  setDocuments(state, documents) {
    state.documents = documents;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setError(state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
